<template>
	<symbol :id="`${prefix}minus_another-20`" viewBox="0 0 20 20">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0C4.47705 0 0 4.47714 0 10C0 15.5229 4.47705 20 10 20ZM15 9H5V11H15V9Z"
			class="sign"
		/>
	</symbol>
</template>

<script>
export default {
	name: 'NiIconSymbolMinusAnother20',


	props: {
		prefix: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="sass" scoped >
.sign
	fill: var(--ni-icon-sign, #{$nice_color-red})
</style>
